import { GetSupplierPartnershipsQuery, SupplierPartnershipFragmentFragment } from 'data/__generated__';
import { GET_SUPPLIER_PARTNERSHIPS_QUERY } from 'data/queries/supplierPartnership';
import { apolloClient } from '../../../App';

export const supplierPartnershipsUpdatedOrCreatedHandler = (
    supplierPartnershipsUpdatedOrCreated: SupplierPartnershipFragmentFragment[],
) => {
    let currentSupplierPartnerships = [] as GetSupplierPartnershipsQuery['supplierPartnerships'];

    const result = apolloClient.readQuery<GetSupplierPartnershipsQuery>({ query: GET_SUPPLIER_PARTNERSHIPS_QUERY });
    if (!result) {
        return;
    }
    currentSupplierPartnerships = result.supplierPartnerships;

    const updatedOrCreatedSupplierPartnershipIds = supplierPartnershipsUpdatedOrCreated.map(({ _id }) => _id);
    const nonUpdatedOrCreatedSupplierPartnerships = currentSupplierPartnerships.filter(
        ({ _id }) => !updatedOrCreatedSupplierPartnershipIds.includes(_id),
    );
    const newSupplierPartnerships = [
        ...supplierPartnershipsUpdatedOrCreated,
        ...nonUpdatedOrCreatedSupplierPartnerships,
    ];

    apolloClient.writeQuery({
        query: GET_SUPPLIER_PARTNERSHIPS_QUERY,
        data: { supplierPartnerships: newSupplierPartnerships },
    });
};
